import React, { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { connect } from "react-redux";
import Stack from "@mui/material/Stack";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import {
  Radio,
  Paper,
  ListItem,
  FormControl,
  OutlinedInput,
  InputAdornment,
  Button,
  Typography,
} from "@mui/material";
import { useMsal } from "@azure/msal-react";
import { useSelector } from "react-redux";
import GraphService from "../../../../services/console_services/Graph";
import Loading from "../../Loading";
import AccuracyChart from "../AccuracyChart";
import MultiBarPOOSChart from "./MultiBarPOOSChart";
import { InputLabel, TextField } from "@material-ui/core";
import NPOOS_RPOOS_Overlap_Table from "./NPOOS_RPOOS_Overlap_Table";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { exportToExcel } from "react-json-to-excel";
import SwitchComponent from "./SwitchComponent";
import { styled } from "@mui/material";
import CustomScrollButton from "../../ReusableComponents/CustomTabScrollButton";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={1}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const CustomTabs = styled(Tabs)({
  "& .MuiTabs-flexContainer": {
    display: "flex",
    flexWrap: "wrap",
    width: "60vw",
  },
});
const useStyles = makeStyles((_theme) => ({
  root: {
    flexGrow: 1,
    dispatch: "flex",
    padding: "10px",
  },
  paper: {
    boxShadow: "none !important",
  },
  loader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "58vh",
    width: "100%",
    position: "relative",
    top: 0,
    left: 0,
  },
  select: {
    borderColor: "transparent",
    borderStyle: "none",
    height: "30px",
    width: "120px",
    borderRadius: "4px !important",
    background: "var(--Neutral-Colors-White, #FFF)",
    fontSize: "14px !important",
    color: "#404041 !important",
  },
  main: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    padding: "0px 10px",
  },
  appBar: {
    padding: "10px",
    "& .MuiTabs-scroller": {
      overflow: "visible !important",
    },
  },
  tab: {
    background: "#FFF",
    boxShadow:
      "0px 2px 4px 0px rgba(0, 0, 0, 0.10), 0px 4px 12px 0px rgba(0, 0, 0, 0.10)",
    flex: 1,
    minHeight: "30px",
    borderRadius: "8px",
  },
  activeTabs: {
    color: "#FFF",
    textAlign: "center",
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    fontWeight: "500",
    textTransform: "none",
    borderRight: "1px solid #92949747",
    minHeight: "30px",
    border: "1px solid var(--Neutral-Colors-Off-White, #E6E7E8)",
    background: "var(--Nestle_Blue, #0067A1)",
  },
  inActiveTabs: {
    color: "#59595A",
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    textTransform: "none",
    minHeight: "30px",
    opacity: 1,
    border: "1px solid var(--Neutral-Colors-Off-White, #E6E7E8)",
    background: "var(--Neutral-Colors-White, #FFF)",
  },
  indicator: {
    display: "none",
  },
  filter: {
    fontSize: "14px",
    margin: "0px 2px",
  },
  dropDownLabel: {
    marginTop: "2px",
  },
}));

const GraphViewPOOS = ({
  tabIndex,
  Module,
  Network,
  DC,
  Products,
  Division,
  PL3,
  graphViewTabList,
  date,
  applyFilter,
  role,
  moduleTabIndexChange,
  setUnitValue,
  setDetailsSwitch,
  setIncludeNPOOS,
  setPOOSRadioButton,
}) => {
  const classes = useStyles();
  const { instance } = useMsal();
  // const [chartData, setChartData] = useState([]);
  // const chartData = [];
  const unitValue = useSelector((state) => state?.filter?.unit);
  const tabValue = useSelector((state) => state?.tabs?.moduleTabIndex);
  // const [categoryList, setCategoryList] = useState("");
  // const categoryList = "";
  const [graphData, setGraphData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [metric, setMetric] = useState("Daily");
  const activeTab = graphViewTabList.filter(
    (item) => item.index === tabValue
  )[0].name;
  const activeFlagValue = useSelector((state) => state?.filter?.activeFlag);
  const detailsSwitch = useSelector((state) => state?.filter?.detailsSwitch);
  const includeNPOOS = useSelector((state) => state?.filter?.includeNPOOS);
  const recomVsActiveRadioSelected = useSelector(
    (state) => state?.filter?.radioButtonPOOS
  );

  const [searchValue, setSearchValue] = useState("");

  const radioOptions = () => {
    const optionsMap = {
      "N POOS Risk": ["Division", "SKU", "PL3"],
      "R POOS Risk": ["Division", "SKU", "PL3"],
      "N POOS Reason": [],
      "R POOS Reason": [],
      "Recom vs Active": ["National", "Regional"],
      Diagnostics: [],
      "NPOOS RPOOS Overlap": [],
    };

    return optionsMap[activeTab] || [];
  };

  const [selectedRadioValue, setSelectedRadioValue] = useState(
    graphViewTabList[tabValue]?.value === "Recom vs Active"
      ? recomVsActiveRadioSelected
      : radioOptions()[0]
  );

  const getGraphData = (params) => {
    setLoading(true);
    GraphService.getGraph(params, instance)
      .then((data) => {
        if (data?.data) {
          setGraphData(data?.data);
        }
      })
      .catch((error) => console.error("Error:", error))
      .finally(() => setLoading(false));
  };

  const getType = () => {
    if (graphViewTabList[tabValue]?.value === "R POOS Risk") {
      if (!detailsSwitch && !includeNPOOS) {
        return "R POOS Risk";
      } else if (detailsSwitch && !includeNPOOS) {
        return "R POOS Risk ON";
      } else if (!detailsSwitch && includeNPOOS) {
        return "Include NPOOS ON";
      } else if (detailsSwitch && includeNPOOS) {
        return "R POOS Risk With NPOOS";
      }
    } else if (graphViewTabList[tabValue]?.value === "R POOS Reason") {
      if (includeNPOOS) {
        return graphViewTabList[tabValue]?.value + " With NPOOS";
      } else {
        return graphViewTabList[tabValue]?.value;
      }
    } else if (
      graphViewTabList[tabValue]?.value === "N POOS Risk" &&
      detailsSwitch
    ) {
      return graphViewTabList[tabValue]?.value + " ON";
    } else if (
      graphViewTabList[tabValue]?.value === "Recom vs Active" &&
      metric === "Weekly"
    ) {
      return graphViewTabList[tabValue]?.value + " Weekly";
    } else {
      return graphViewTabList[tabValue]?.value;
    }
  };

  const memoizedParams = useMemo(() => {
    const params = {
      section: Module,
      type: getType(),
      name: unitValue,
      units: unitValue,
      X_Axis: selectedRadioValue,
      Level: role,
      filter: {
        RecommendedDC: DC,
        Network: Network,
        PL3: PL3,
        Division: Division,
        Products: Products,
        startDate: date?.[0],
        endDate: date?.[1],
        ActiveFlag: activeFlagValue,
      },
    };
    if (activeTab === "Recom vs Active" && includeNPOOS) {
      params.isNpoosIncluded = true; // Adds 'newKey' if the condition is true
    }
    return params;
  }, [
    Module,
    tabValue,
    role,
    DC,
    Network,
    PL3,
    Division,
    Products,
    date,
    activeFlagValue,
    unitValue,
    selectedRadioValue,
    detailsSwitch,
    includeNPOOS,
    metric,
  ]);

  useEffect(() => {
    // Conditional check to avoid unnecessary API calls
    if (
      !memoizedParams.section ||
      !memoizedParams.type ||
      !memoizedParams.name ||
      !memoizedParams.filter.startDate ||
      !memoizedParams.filter.endDate
    ) {
      return;
    }
    getGraphData(memoizedParams);
  }, [memoizedParams, applyFilter]);

  const getDataForExport = () => {
    const params = {
      module: Module,
      X_Axis: selectedRadioValue,
      isWeekly: metric === "Weekly" ? true : false,
      filter: {
        RecommendedDC: DC,
        Network: Network,
        PL3: PL3,
        Division: Division,
        Products: Products,
        startDate: date?.[0],
        endDate: date?.[1],
      },
      activeTab: activeTab,
    };
    if (activeTab === "Recom vs Active" && includeNPOOS) {
      params.isNpoosIncluded = true; // Adds 'newKey' if the condition is true
    }
    GraphService.getExcelData(params, instance)
      .then((data) => {
        if (data?.data) {
          exportToExcel(
            data?.data,
            activeTab === "Recom vs Active"
              ? "RecomVsActiveData"
              : "NPOOS_RPOOS_Overlap_Data"
          );
        }
      })
      .catch((error) => console.error("Error:", error));
  };

  const handleChange = (_event, newValue) => {
    moduleTabIndexChange(newValue);
    if (newValue === 4) {
      setSelectedRadioValue(recomVsActiveRadioSelected);
    } else {
      setSelectedRadioValue("Division");
    }
    if (newValue === 4) {
      setIncludeNPOOS(false);
    }
  };

  const handleMetricChange = (event) => {
    setMetric(event.target.value);
  };

  const handleMutiBarSwitchChange = (event) => {
    setDetailsSwitch(event.target.checked);
  };

  const handleIncludeNPOOSChange = (event) => {
    setIncludeNPOOS(event.target.checked);
  };

  const handleRadioChange = (selectedFilter) => {
    setSelectedRadioValue(selectedFilter);
    if (selectedFilter === "National") {
      setIncludeNPOOS(false);
    }
    if (activeTab === "Recom vs Active") {
      setPOOSRadioButton(selectedFilter);
    }
  };

  const handleUniteChange = (event) => {
    setUnitValue(event.target.value);
  };

  const handleChangeSearchValue = (event) => {
    setSearchValue(event.target.value);
  };

  const handleExportExcel = () => {
    getDataForExport();
  };

  const renderChart = () => {
    // const chartProps = {
    //     graphData,
    //     chartData,
    //     categoryList,
    //     showAnnotation: true,
    //     activeTab
    // };

    if (
      activeTab === "N POOS Risk" ||
      activeTab === "R POOS Risk" ||
      activeTab === "N POOS Reason" ||
      activeTab === "R POOS Reason" ||
      activeTab === "Recom vs Active"
    ) {
      return (
        <MultiBarPOOSChart
          graphData={graphData}
          activeTab={activeTab}
          type={unitValue}
          isSwichON={detailsSwitch}
          showReportRunDate={true}
        />
      );
    } else if (activeTab === "Diagnostics") {
      return (
        <AccuracyChart
          graphData={graphData}
          showAnnotation={false}
          activeTab={activeTab}
          type={unitValue}
        />
      );
    } else if (activeTab === "NPOOS RPOOS Overlap") {
      return (
        <NPOOS_RPOOS_Overlap_Table
          tableData={graphData}
          searchValue={searchValue}
        />
      );
    }
  };

  return (
    <Paper elevation={0} className={classes.paper}>
      {loading ? (
        <div className={classes.loader}>
          <Loading />
        </div>
      ) : (
        <>
          <Box
            sx={{
              maxWidth: "70vw",
              overflow: "hidden",
            }}
          >
            <Tabs
              value={tabValue}
              onChange={handleChange}
              className={classes.tab}
              aria-label="simple tabs example"
              variant="scrollable"
              scrollButtons="auto"
              ScrollButtonComponent={CustomScrollButton}
              classes={{ indicator: classes.indicator }}
            >
              {graphViewTabList.map((item, index) => (
                <Tab
                  key={index}
                  className={
                    tabValue === index
                      ? classes.activeTabs
                      : classes.inActiveTabs
                  }
                  label={item.name}
                  style={{
                    minHeight: "35px",
                  }}
                  {...a11yProps(index)}
                />
              ))}
            </Tabs>
          </Box>
          {graphViewTabList?.map((_item, index) => (
            <TabPanel key={index} value={tabIndex} index={index}>
              <Stack
                direction="row"
                flexDirection={"column"}
                sx={{ padding: "22px 8px" }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  {activeTab === "NPOOS RPOOS Overlap" && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <FormControl variant="outlined">
                        <OutlinedInput
                          id="outlined-adornment-weight"
                          placeholder="Search by material or location"
                          type="text"
                          value={searchValue}
                          onChange={handleChangeSearchValue}
                          endAdornment={
                            <InputAdornment position="end">
                              {searchValue ? (
                                <ClearIcon
                                  style={{
                                    cursor: "pointer",
                                  }}
                                  onClick={() => setSearchValue("")}
                                />
                              ) : (
                                <SearchIcon />
                              )}
                            </InputAdornment>
                          }
                          aria-describedby="outlined-weight-helper-text"
                          inputProps={{
                            "aria-label": "weight",
                          }}
                          sx={{
                            height: "35px",
                            fontSize: "14px",
                            width: "300px",
                            borderRadius: "10px",
                            marginLeft: "10px",
                          }}
                        />
                      </FormControl>
                      <Button
                        variant="contained"
                        startIcon={<FileDownloadIcon fontSize="18px" />}
                        sx={{
                          fontFamily: "Poppins, sans-serif", // Make sure Poppins is specified here
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#59595A",
                          background: "#ffffff",
                          height: "30px",
                          marginRight: "20px",
                          marginLeft: "20px",
                          textTransform: "none",
                          boxShadow: "none",
                          border: "1px solid #D3D3D3",
                          "&:hover": {
                            background: "#ffffff", // Prevent background color change on hover
                            boxShadow: "none", // Prevent shadow changes on hover
                          },
                        }}
                        onClick={handleExportExcel}
                      >
                        Export
                      </Button>
                    </div>
                  )}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      columnGap: "20px",
                      marginLeft: "20px",
                    }}
                  >
                    {activeTab !== "NPOOS RPOOS Overlap" && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <div>
                          <Typography
                            sx={{
                              fontSize: "12px",
                              fontWeight: 500,
                              color: "#aaaaaaff",
                              mb: "2px",
                            }}
                          >
                            Unit
                          </Typography>
                        </div>
                        <Select
                          labelId="active-select-label"
                          value={unitValue}
                          onChange={handleUniteChange}
                          className={classes.select}
                          displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                        >
                          <MenuItem value="Dollars">Dollar</MenuItem>
                          <MenuItem value={"Cases"}>Cases</MenuItem>
                          {activeTab === "Diagnostics" ? (
                            <MenuItem value={"Pallets"}>Pallets</MenuItem>
                          ) : (
                            <MenuItem value={"SKU"}>SKUs</MenuItem>
                          )}
                        </Select>
                      </div>
                    )}
                    {activeTab === "Recom vs Active" && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <div>
                          <Typography
                            sx={{
                              fontSize: "12px",
                              fontWeight: 500,
                              color: "#aaaaaaff",
                              mb: "2px",
                            }}
                          >
                            By
                          </Typography>
                        </div>
                        <Select
                          labelId="active-select-label"
                          value={metric}
                          onChange={handleMetricChange}
                          className={classes.select}
                          displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                        >
                          <MenuItem value="Daily">Daily</MenuItem>
                          <MenuItem value={"Weekly"}>Weekly</MenuItem>
                        </Select>
                      </div>
                    )}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      alignSelf: "flex-end",
                    }}
                  >
                    {(activeTab === "R POOS Risk" ||
                      activeTab === "R POOS Reason") && (
                      <SwitchComponent
                        value={includeNPOOS}
                        handleChange={handleIncludeNPOOSChange}
                        labelValue={"Include NPOOS"}
                      />
                    )}
                    {(activeTab === "N POOS Risk" ||
                      activeTab === "R POOS Risk") && (
                      <SwitchComponent
                        value={detailsSwitch}
                        handleChange={handleMutiBarSwitchChange}
                        labelValue={"Detail Split"}
                      />
                    )}
                    {activeTab === "Recom vs Active" && (
                      <>
                        <SwitchComponent
                          value={includeNPOOS}
                          handleChange={handleIncludeNPOOSChange}
                          labelValue={"Include NPOOS"}
                          disableSwitch={
                            selectedRadioValue === "National" ? true : false
                          }
                        />
                        <Button
                          variant="contained"
                          startIcon={<FileDownloadIcon fontSize="18px" />}
                          sx={{
                            fontFamily: "Poppins, sans-serif", // Make sure Poppins is specified here
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#59595A",
                            background: "#ffffff",
                            height: "30px",
                            marginRight: "20px",
                            marginLeft: "20px",
                            textTransform: "none",
                            boxShadow: "none",
                            border: "1px solid #D3D3D3",
                            "&:hover": {
                              background: "#ffffff", // Prevent background color change on hover
                              boxShadow: "none", // Prevent shadow changes on hover
                            },
                          }}
                          onClick={handleExportExcel}
                        >
                          Export
                        </Button>
                      </>
                    )}
                  </div>
                </div>
                <div style={{ marginLeft: "15px",marginTop:"10px" }}>
                  {radioOptions()?.map(
                    (option) =>
                      (((activeTab === "N POOS Risk" ||
                        activeTab === "R POOS Risk") &&
                        detailsSwitch) ||
                        activeTab === "Recom vs Active") && (
                        <React.Fragment key={option}>
                          <Radio
                            value={option}
                            checked={selectedRadioValue === option}
                            onChange={() => handleRadioChange(option)}
                            size="small"
                            inputProps={{ "aria-label": option }}
                            sx={{
                              color: "#359DD0 !important",
                              "&.Mui-checked": {
                                color: "#359DD0 !important",
                              },
                            }}
                          />
                          <span
                            className={classes.filter}
                            style={{
                              color:
                                selectedRadioValue ===
                                (Module === "SNO" ? "Overall" : "Network")
                                  ? "#359DD0"
                                  : "#359DD0",
                            }}
                          >
                            {option}
                          </span>
                        </React.Fragment>
                      )
                  )}
                </div>
              </Stack>
              {renderChart()}
            </TabPanel>
          ))}
        </>
      )}
    </Paper>
  );
};

GraphViewPOOS.propTypes = {
  tabIndex: PropTypes.number.isRequired,
  tabChange: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  tabIndex: state.tabs.index,
  Network: state.filter.Network,
  DC: state.filter.DC,
  Products: state.filter.Products,
  PL3: state.filter.PL3,
  date: state.filter.Date,
  Division: state.filter.Division,
  applyFilter: state.filter.applyFilter,
  role: state.login.role,
});

const mapDispatchToProps = (dispatch) => ({
  tabChange: (newValue) => dispatch({ type: "TAB_INDEX", payload: newValue }),
  moduleTabIndexChange: (newValue) =>
    dispatch({ type: "MODULE_TAB_INDEX", payload: newValue }),
  setUnitValue: (newValue) =>
    dispatch({ type: "SET_UNIT_VALUE", payload: newValue }),
  setDetailsSwitch: (newValue) =>
    dispatch({ type: "SET_DETAILS_SWITCH", payload: newValue }),
  setIncludeNPOOS: (newValue) =>
    dispatch({ type: "SET_INCLUDE_NPOOS", payload: newValue }),
  setPOOSRadioButton: (newValue) =>
    dispatch({ type: "SET_POOS_RADIO_BUTTON", payload: newValue }),
});

export default connect(mapStateToProps, mapDispatchToProps)(GraphViewPOOS);
